import { useEffect, useRef, useState } from 'react';
import { MenuItemVariantDto } from '../../../../generated-api';
import classNames from 'classnames';

interface Props {
  item: MenuItemVariantDto;
}

export const ItemName = ({ item }: Props) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [fontSizeClass, setFontSizeClass] = useState('');
  const [lineClampClass, setLineClampClass] = useState('line-clamp-1');

  let itemName = item.name;

  if (item.variantInfo) {
    const variantName = item.variantInfo.name ? ` ${item.variantInfo.name}` : '';

    const variantUnitString = item.variantInfo.unit ? ` ${item.variantInfo.quantity} ${item.variantInfo.unit}` : '';

    itemName = `${item.name}${variantName}${variantUnitString}`;
  }

  useEffect(() => {
    const adjustFontSize = () => {
      const element = textRef.current;
      if (element) {
        const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
        const lines = Math.round(element.scrollHeight / lineHeight);

        if (lines === 1) {
          setLineClampClass('line-clamp-1');
        } else if (lines === 2) {
          setFontSizeClass('text-small');
          setLineClampClass('line-clamp-2');
        } else {
          setFontSizeClass('text-extra-small');
          setLineClampClass('line-clamp-3');
        }
      }
    };

    adjustFontSize();
    window.addEventListener('resize', adjustFontSize);

    return () => {
      window.removeEventListener('resize', adjustFontSize);
    };
  }, [item.name]);
  return (
    <div>
      <span
        ref={textRef}
        className={classNames('text-left text-bold leading-[20px] break-words', fontSizeClass, lineClampClass)}
      >
        {itemName}
      </span>
    </div>
  );
};
